import React from "react";
import classnames from "classnames";
import i18n from "~/i18n";
import Button from "~/Common-Objects/UI/Forms/Button/Button";
import SimpleBar from "~/Common-Objects/Charts/SimpleBar";
import SquareChip from "~/Common-Objects/UI/Chips/SquareChip.jsx";
import FormatNumberFuncs from "../../../../../../../Classes/numberFormatFunctions";
export default function PollResultsQuestion({
  displayIndex,
  question,
  noOfResponses,
  onViewResponsesClick,
  className,
  children,
  ...rest
}) {
  const { answers, question: q, label } = question;
  let average = null;

  if (question.value === "satisfaction" || question.value === "promoter") {
    const answersTotal = answers.value.reduce((acc, current) => {
      return acc + current.answers * current.label;
    }, 0);

    average = (answersTotal / noOfResponses).toFixed(1);
  }

  const classes = classnames("campaign-poll-results-question", className);

  return (
    <div className={classes} {...rest}>
      <div className="campaign-poll-results-question__header">
        <div>
          <div className="campaign-poll-results-question__chips">
            <SquareChip className="square-chip-secondary">
              {label}
            </SquareChip>

            {average && (
              <SquareChip>
                {i18n.t("campaigns:polls.average")} {average}
              </SquareChip>
            )}
          </div>

          <h3 className="h5">
            Q{displayIndex} – {q.value}
          </h3>
        </div>

        <Button className="button-sml" onClick={onViewResponsesClick}>
          {i18n.t("campaigns:polls.viewResponses")}
        </Button>
      </div>

      <div className="campaign-poll-results-question__bars-scroller">
        <ul className="campaign-poll-results-question__bars faux-list">
          {answers.value.map((answer) => {
            let percentage = (answer.answers / noOfResponses) * 100 || 0;
            percentage = FormatNumberFuncs.formatNumber(percentage, 2)
            return (
              <li key={answer.label}>
                <SimpleBar
                  percentage={percentage}
                  labelTop={`${answer.answers} – ${percentage}%`}
                  labelBottom={answer.label}
                />
              </li>
            );
          })}
        </ul>
      </div>

      {children}
    </div>
  );
}
